module.exports = __webpack_public_path__ + "static/grade_chart-5874e3d33a5bf8b86cdcda06c8e02032.png";